import { FleetUUIDs } from '../enums';
import { useFleetOverride } from '../queries';
import { useFleet } from './useFleet';
import { useHasAccess } from './useHasAccess';

const fleetsWithAssetManagement = [FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot];

export const useAssetManagement = (): boolean => {
  const { data: fleetUUID } = useFleetOverride();
  if (!fleetUUID) {
    return false;
  }

  return fleetsWithAssetManagement.includes(fleetUUID as FleetUUIDs);
};

export const useAssetManagementForCustomer = (): boolean => {
  const hasAccess = useHasAccess();
  const isAssetManagement = useAssetManagement();

  if (isAssetManagement && !hasAccess) {
    return true;
  }
  return false;
};

export const useCanViewLargeLicensePlate = (): boolean => {
  const fleet = useFleet();
  const hasAccess = useHasAccess();
  if (hasAccess) {
    return true;
  }

  if (fleet.uuid === FleetUUIDs.MBTA || fleet.uuid === FleetUUIDs.MBTAPrePilot) {
    return false;
  }

  return true;
};
